import Vue from 'vue'
const allowedTypes = [
  'Video', 'Image', 'HTML5app', 'HTML5_GRAPHICS', 'URL',
  'Executable', 'Unity3D', 'PlayList', 'PlayListExtended',
  'PlayListLayout', 'PlayListLayoutExtended',
  'PlayListUnassigned', 'MediaUnassigned'
]
const mutations = {
  SET_RELOADING_MEDIA (state, status) {
    Vue.set(state, 'media_reloading', status)
  },
  SET_MEDIALIST (state, mediaList) {
    mediaList.map(obj => Object.freeze(obj))
    mediaList.sort((a, b) => b.updatedAt - a.updatedAt)
    Vue.set(state, 'media_list', mediaList)
    Vue.set(state, 'media_count', mediaList.length)
  },
  REMOVE_FROM_MEDIALIST (state, medium) {
    let oldMediumIndex = state.media_list.findIndex(oldMedium => oldMedium.id === medium.id)
    if (oldMediumIndex === -1) {
      return
    }
    Vue.delete(state.media_list, oldMediumIndex)
  },
  ADD_TO_MEDIALIST (state, data) {
    const media = !Array.isArray(data) ? [data] : data
    for (const medium of media) {
      if (!medium) return
      let oldMediumIndex = state.media_list.findIndex(oldMedium => oldMedium.id === medium.id)
      if (oldMediumIndex !== -1) {
        return
      }
      state.media_list.push(medium)
    }
  },
  UPDATE_MEDIUM_IN_MEDIALIST (state, medium) {
    let updatedMediumIndex = state.media_list.findIndex(oldMedium => oldMedium.id === medium.id)
    if (updatedMediumIndex === -1) {
      return
    }
    Vue.set(state.media_list, updatedMediumIndex, medium)
  },
  SET_MEDIALIST_COUNT (state, count) {
    Vue.set(state, 'media_count', count)
  },
  SET_LOCAL_PLAYLIST_CACHE (state, count) {
    count.map(obj => Object.freeze(obj))
    Vue.set(state, 'local_playlists_cache', count)
  },
  SET_MEDIA_TAGS (state, tags) {
    // tags.map(obj => Object.freeze(obj))
    Vue.set(state, 'media_tags', tags)
  },
  SET_MEDIA_TAGS_UNUSED (state, tags) {
    // tags.map(obj => Object.freeze(obj))
    Vue.set(state, 'media_tags_unused', tags)
  },
  CLEAR_MEDIA_TYPES (state) {
    Vue.set(state, 'media_types', [])
  },
  SET_MEDIA_TYPES (state) {
    const allNonDesktopMedia = state.media_list.filter(medium => medium.type !== 'PlayListDesktop')
    const typesInList = [
      'Image',
      'Video',
      'PlayListLayout',
      'PlayListLibraryFolder',
      'PlayList',
      'PlayListLibraryRoot',
      'PlayListExtended',
      'HTML5app',
      'HTMLzip',
      'Audio'
    ]
    const mediaTypes = []
    for (const mediaType of typesInList) {
      const mediaInListInType = allNonDesktopMedia.filter(medium => medium.type === mediaType)
      const mediaIdsInType = [...new Set(mediaInListInType.map(medium => medium.id))]
      mediaTypes.push({
        name: mediaType,
        media: mediaIdsInType
      })
      let typeInActiveFilter = state.media_filter.left.mediaTypes.find(mt => mt.name === mediaType)
      if (typeInActiveFilter) {
        Vue.set(typeInActiveFilter, 'media', mediaIdsInType)
      }
    }
    Vue.set(state, 'media_types', mediaTypes)
    state.media_types.push({
      name: 'AllMedia',
      media: [...new Set(allNonDesktopMedia.map(medium => medium.id))]
    })
  },
  ADD_MEDIA_UNASSIGNED_TO_MEDIA_TYPES (state, mediaUsedInDesktops) {
    let allMediaIds = state.media_list.map(item => item.id)
    let mediaInUsedInDesktopsMediaIds = mediaUsedInDesktops.map(item => item.Medium)
    let playlistThatAreLibraryFolder = state.media_list.filter((el) => el.type === 'PlayListLibraryFolder').map(item => item.id)
    let PlayListDesktops = []
    if (state.media_types.findIndex(mt => mt.name === 'PlayListDesktop') > -1) {
      PlayListDesktops = state.media_types.find(mt => mt.name === 'PlayListDesktop').media
    }
    let mediaNotUnassigned = [...new Set([
      ...(state.media_types.find(mt => mt.name === 'PlayListLibraryRoot') ? state.media_types.find(mt => mt.name === 'PlayListLibraryRoot').media : []),
      ...PlayListDesktops,
      ...playlistThatAreLibraryFolder,
      ...mediaInUsedInDesktopsMediaIds
    ])]

    let orphanedMediaIds = allMediaIds.filter((el) => !mediaNotUnassigned.includes(el))
    // if (orphanedMediaIds.length > 0) {
    state.media_types.push({
      name: 'UnassignedMedia',
      media: orphanedMediaIds
    })
    // }
  },
  SET_SELECTED_LEFT (state, media) {
    Vue.set(state, 'media_selected_left', media)
  },
  ADD_MEDIUM_SELECTED_LEFT (state, medium) {
    if (state.media_selected_left.findIndex(ms => ms.id === medium.id) === -1) {
      state.media_selected_left.push(medium)
    }
  },
  ADD_MEDIUM_SELECTED_RIGHT (state, medium) {
    if (state.media_selected_right.findIndex(ms => ms.id === medium.id) > -1) {
      state.media_selected_right.push(medium)
    }
  },
  REMOVE_MEDIUM_SELECTED_LEFT (state, medium) {
    const mediumIndex = state.media_selected_left.findIndex(mediumSelected => mediumSelected.id === medium.id)
    state.media_selected_left.splice(mediumIndex, 1)
  },
  REMOVE_MEDIUM_SELECTED_RIGHT (state, medium) {
    const mediumIndex = state.media_selected_right.findIndex(mediumSelected => mediumSelected.id === medium.id)
    state.media_selected_right.splice(mediumIndex, 1)
  },
  ADD_SELECTED_RIGHT (state, media) {
    Vue.set(state, 'media_selected_right', media)
  },
  CLEAR_SELECTED_LEFT (state) {
    Vue.set(state, 'media_selected_left', [])
  },
  CLEAR_SELECTED_RIGHT (state) {
    Vue.set(state, 'media_selected_right', [])
  },
  TOGGLE_MEDIUM_SELECTED_LEFT (state, medium) {
    const mediumIndex = state.media_selected_left.findIndex(mediumSelected => mediumSelected.id === medium.id)
    if (mediumIndex > -1) {
      state.media_selected_left.splice(mediumIndex, 1)
    } else {
      state.media_selected_left.push(medium)
    }
  },
  TOGGLE_MEDIUM_SELECTED_RIGHT (state, medium) {
    const mediumIndex = state.media_selected_right.findIndex(mediumSelected => mediumSelected.id === medium.id)
    if (mediumIndex > -1) {
      state.media_selected_right.splice(mediumIndex, 1)
    } else {
      state.media_selected_right.push(medium)
    }
  },
  SET_PLAYITEMS_SELECTED_RIGHT (state, playitems) {
    playitems.map(obj => Object.freeze(obj))

    Vue.set(state, 'playitems_selected_right', playitems)
  },
  SET_PLAYITEMS_SELECTED_LEFT (state, playitems) {
    playitems.map(obj => Object.freeze(obj))

    Vue.set(state, 'playitems_selected_left', playitems)
  },
  TOGGLE_PLAYITEM_SELECTED_RIGHT (state, playitem) {
    const playitemIndex = state.playitems_selected_right.findIndex(pi => pi.id === playitem.id)
    if (playitemIndex === -1) {
      state.playitems_selected_right.push(playitem)
    } else {
      state.playitems_selected_right.splice(playitemIndex, 1)
    }
  },
  TOGGLE_PLAYITEM_SELECTED_LEFT (state, playitem) {
    const playitemIndex = state.playitems_selected_left.findIndex(pi => pi.id === playitem.id)
    if (playitemIndex === -1) {
      state.playitems_selected_left.push(playitem)
    } else {
      state.playitems_selected_left.splice(playitemIndex, 1)
    }
  },
  ADD_PLAYITEM_SELECTED_RIGHT (state, playitem) {
    state.playitems_selected_right.push(playitem)
  },
  REMOVE_PLAYITEM_SELECTED_RIGHT (state, playitem) {
    const playitemIndex = state.playitems_selected_right.findIndex(pi => pi.id === playitem.id)
    state.playitems_selected_right.splice(playitemIndex, 1)
  },
  SET_DROP_ALLOWED (state, boolean) {
    Vue.set(state, 'drop_allowed', boolean)
  },
  SET_DRAGGED_MEDIUM (state, value) {
    const mediumSelectedLeft = JSON.parse(JSON.stringify(state.media_selected_left[0]))
    mediumSelectedLeft.dragged = value
    state.media_selected_left.splice(0, 1, mediumSelectedLeft)
  },
  SET_DRAGGED_OVER_PLAYITEM (state, data) {
    Vue.set(state, 'dragged_over_playitem', data)
  },
  RESET_DRAGGED_OVER_PLAYITEM (state) {
    Vue.set(state, 'dragged_over_playitem', null)
  },
  DELETE_TAG_FROM_MEDIUM (state, data) {
    // delete from medium
    const mediumWithTags = state.media_list.find(medium => medium.id === data[1])
    const tagIndex = mediumWithTags.MediumTags.findIndex(tag => tag.id === data[0])
    if (tagIndex > -1) mediumWithTags.MediumTags.splice(tagIndex, 1)
    // adjust filter
    const tagInFilter = state.media_tags.find(tag => tag.id === data[ 0 ])
    // it is last medium with this tag, remove tag from filter, add to media_tags_unused
    if (tagInFilter.media.length === 1) {
      const unusedTagIndex = state.media_tags.findIndex(tag => tag.id === data[0])
      state.media_tags.splice(unusedTagIndex, 1)
      delete tagInFilter.media
      state.media_tags_unused.push(tagInFilter)
    } else {
    // remove medium from tag filter
      const mediumIndexToBeRemoved = tagInFilter.media.findIndex(d => d === data[1])
      tagInFilter.media.splice(mediumIndexToBeRemoved, 1)
      const tagInFilterIndex = state.media_tags.findIndex(tag => tag.id === data[0])
      // still ugly hack to refresh VUEX->DOM
      Vue.set(state.media_tags, tagInFilterIndex, tagInFilter)
    }
  },
  ADD_TAG_TO_MEDIUM (state, data) {
    const mediumWithTags = state.media_list.find(medium => medium.id === data[1])
    let tagIndexUnused
    let tagIndexUsed
    let tag = state.media_tags.find(tag => tag.id === data[0])
    if (!tag) {
      tagIndexUnused = state.media_tags_unused.findIndex(tag => tag.id === data[0])
      tag = state.media_tags_unused[tagIndexUnused]
    }
    mediumWithTags.MediumTags.push(tag)
    if (tagIndexUnused > -1) {
      state.media_tags_unused.splice(tagIndexUnused, 1)
      let tagToInsert = tag
      tagToInsert.media = []
      tagToInsert.media.push(mediumWithTags.id)
      state.media_tags.push(tagToInsert)
    } else {
      tagIndexUsed = state.media_tags.findIndex(tag => tag.id === data[0])
      state.media_tags[tagIndexUsed].media = [data[1]]
    }
  },
  ADD_MEDIUM_TAG_TO_NETWORK_MEDIUM_TAGS (state, tag) {
    state.media_tags.push(tag)
  },
  /** FILTER */
  SET_TAGS_IN_FILTER (state, data) {
    let side = data[0]
    let tags = data[1]
    Vue.set(state.media_filter[side], 'mediaTags', tags)
  },
  TOGGLE_TAG_IN_FILTER (state, data) {
    let side = data[0]
    let tag = data[1]
    let tagIndex = state.media_filter[side].mediaTags.findIndex(filterTag => filterTag.id === tag.id)
    if (tagIndex === -1) {
      state.media_filter[side].mediaTags.push(tag)
    } else {
      state.media_filter[side].mediaTags.splice(tagIndex, 1)
    }
    state.pagination[side].page = 1
    if (state.media_filter[side].mediaTags.length < 2) {
      state.media_filter[side].mediaTagsAll = false
    }
  },
  TOGGLE_TYPE_IN_FILTER (state, data) {
    let side = data[0]
    let type = data[1]
    if (!type) return
    let typeIndex = state.media_filter[side].mediaTypes.findIndex(filterType => filterType.name === type.name)
    if (typeIndex === -1) {
      state.media_filter[side].mediaTypes.push(type)
    } else {
      state.media_filter[side].mediaTypes.splice(typeIndex, 1)
    }
    state.pagination[side].page = 1
  },
  SET_TYPE_IN_FILTER (state, data) {
    let side = data[0]
    let type = data[1]
    if (typeof type === 'string') {
      type = state.media_types.find(Type => Type.name === type)
    }
    if (!type) return
    state.media_filter[side].mediaTypes = []
    state.media_filter[side].mediaTypes.push(type)
    if (state.media_filter[side].mediaTypes[0].name !== type.name) {
      state.pagination[side].page = 1
    }
  },
  SET_BIGGEST_TYPE_IN_FILTER (state, side) {
    // return
    if (state.media_types.length === 0) return
    var biggestCount = 0
    var biggestIndex
    for (let index = 0; index < state.media_types.length; index++) {
      if (
        allowedTypes.indexOf(state.media_types[index].name) > -1 &&
        state.media_types[index].media.length > biggestCount
      ) {
        biggestCount = state.media_types[index].media.length
        biggestIndex = index
      }
    }
    state.media_filter[side].mediaTypes = []
    state.media_filter[side].mediaTypes.push(state.media_types[biggestIndex])
    state.pagination[side].page = 1
  },
  TOGGLE_SHOW_THUMBS (state) {
    Vue.set(state, 'show_thumbs', !state.show_thumbs)
  },
  TOGGLE_TAG_FILTER_VISIBLE (state) {
    Vue.set(state, 'show_tag_filter', !state.show_tag_filter)
  },
  SET_SELECTED_LIBRARY_FOLDER (state, folderMedium) {
    Vue.set(state, 'selected_library_folder', folderMedium)
  },
  SET_TAG_ALLANY_IN_FILTER (state, data) {
    let side = data[0]
    let allany = data[1]
    state.media_filter[side].mediaTagsAll = allany
    state.pagination[side].page = 1
  },
  CLEAR_FILTER (state, side) {
    state.media_filter[side].mediaTags = []
    state.media_filter[side].mediaTagsAll = false
    // state.media_filter[side].mediaTypes = []
  },
  CLEAR_TYPE_FILTER (state, side) {
    state.media_filter[side].mediaTypes = []
  },
  /** EDIT HISTORY */
  ADD_MEDIUMID_TO_MEDIA_EDIT_HISTORY (state, medium) {
    const mediaHistoryExistsIndex = state.media_edit_history.findIndex(mpi => mpi.id === medium.id)
    if (mediaHistoryExistsIndex > -1) {
      state.media_edit_history.splice(mediaHistoryExistsIndex, 1)
    }
    state.media_edit_history.unshift(medium)
    if (state.media_edit_history.length > 25) {
      state.media_edit_history.length = 25
    }
  },
  CLEAR_EDIT_HISTORY (state) {
    state.media_edit_history = []
  },
  /** PAGINATION */
  PAGINATION_SET_LIMIT (state, data) {
    state.pagination[data[0]].limit = data[1]
  },
  PAGINATION_SET_PAGE (state, data) {
    state.pagination[data[0]].page = data[1]
  },
  /** BREADCRUMBS */
  ADD_MEDIUMID_TO_BREADCRUMBS (state, mediumId) {
    if (state.breadcrumbs.indexOf(mediumId) === -1) state.breadcrumbs.push(mediumId)
  },
  CLEAR_BREADCRUMBS (state) {
    state.breadcrumbs = []
  },
  STRIP_BREADCRUMBS (state, index) {
    state.breadcrumbs.length = (index + 1)
  },
  UPDATE_SEARCH_STRING (state, string) {
    state.search_by_string = string
  }
}

export default mutations



//////////////////
// WEBPACK FOOTER
// ./state/medium/medium.mutations.js
// module id = null
// module chunks = 